import { getJson, postJson } from './fetch';
import {
  BASE_PATH,
  authMethods,
  routes
} from './constants';

const AUTH_BASE_PATH = '/auth';

export const LOGIN_PATH = `${AUTH_BASE_PATH}/login`;

export const logInAs = (user) => postJson(LOGIN_PATH,
  { username: user.username, password: user.password }, false);

export const logOut = (authMethod) => {
  const logoutPath = `${AUTH_BASE_PATH}/logout`;

  switch (authMethod) {
    case authMethods.SHIBBOLETH:
      window.location.pathname = logoutPath;
      break;
    case authMethods.MULTI_SAML:
      window.location.pathname = logoutPath;
      break;
    case authMethods.IN_APP:
      return postJson(logoutPath).then(() => {
        window.location.pathname = `${BASE_PATH}${routes.login}`;
      });
    default:
      break;
  }

  return Promise.resolve();
};

export const getUsers = () => getJson(`${AUTH_BASE_PATH}/users`);
export const getCurrentUser = () => getJson(`${AUTH_BASE_PATH}/user`);
export const getIdpOptions = () => getJson(`${AUTH_BASE_PATH}/idp-options`);
